import React from "react";
import { Row, Col } from "react-bootstrap";
import { MdEdit } from "react-icons/md";

const TabCardHeader = ({
  title,
  showEditButton = false,
  editing,
  onEditToggle,
}) => {
  return (
    <div className="tab-card-header">
      <Row className="align-items-center">
        <Col>
          <h2 className="tab-card-header-title">{title}</h2>
        </Col>
        <Col className="text-end">
          {showEditButton && (
            <button
              className="btn btn-sm btn-light uredi-btn-tab-card-header"
              onClick={() => onEditToggle()}
            >
              {editing ? (
                <span className="d-flex align-items-center gap-1">
                  Prekliči urejanje <MdEdit />
                </span>
              ) : (
                <span className="d-flex align-items-center gap-1">
                  Uredi <MdEdit />
                </span>
              )}
            </button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TabCardHeader;
